import $ from "jquery";

$(function () {
  const $form = $(".multi-step-form");
  // Find the multi-step-form, and proceed if it exists
  if ($form.length) {
    let curStep = 1;
    const $progress = $(".progress-indicator [data-step]");
    const $elements = $("[data-step]").not($progress);
    const $controls = $("[data-step-control]");
    const $submit = $("[data-submit]");
    let $curInputs = getCurInputs(curStep);

    changeStep(curStep);

    $controls.click(function (e) {
      let $target = $(e.target);
      // Prevent href behaviour
      if ($target.is("a")) {
        e.preventDefault();
      }
      let dir = $target.data("stepControl");
      if (dir == "next") {
        if (validateStep()) {
          // validate before changing steps
          curStep++;
        } else {
          return;
        }
      } else if (dir == "prev") {
        curStep--;
      }
      changeStep(curStep);
      $curInputs = getCurInputs(curStep);
    });

    $submit.click(function (e) {
      e.preventDefault();

      const $recaptcha = $(".g-recaptcha");

      if ($recaptcha.find("#g-recaptcha-response").val() === "") {
        $recaptcha.siblings(".form-error").show();
        return false;
      }

      $form.submit();
    });

    // Quick function to reveal proper elements for the current step
    function changeStep(step) {
      // Show and hide the proper elements
      $.each($elements, function () {
        let $this = $(this);
        if ($this.data("step") == step) {
          $this.show();
        } else {
          $this.hide();
        }
      });

      $.each($progress, function () {
        const $this = $(this);
        const indicatorStep = $this.data("step");

        if (indicatorStep > step) {
          $this.removeClass("is-current is-complete");
        } else if (indicatorStep == step) {
          $this.removeClass("is-complete");
          $this.addClass("is-current");
        } else {
          $this.removeClass("is-current");
          $this.addClass("is-complete");
        }
      });
    }

    function validateFixedAmountDonations() {
      var shouldValidate = $form.attr("should-validate-fixed-price-table");
      if (
        $("#fixed-price-table").length > 0 &&
        $("#fixed-price-table").is(":visible")
      ) {
        console.log("We should validate this");
        const $tableBody = $("#fixedAmountDonationsField tbody");
        const numberOfRows = $tableBody.find("tr").length;
        const $errorContainer = $("#fixedAmountDonationsField .form-error"); // Assuming an error container exists

        // Ensure at least one row exists
        if (numberOfRows < 1) {
          $errorContainer
            .text("Please add at least one fixed amount donation.")
            .show();
          return false;
        }

        // Check if the donation amount is at least $5 for each row
        let allAmountsValid = true;
        $tableBody.find('input[name*="[amountToDonate]"]').each(function () {
          if (parseInt($(this).val(), 10) < 5) {
            $errorContainer
              .text("Each donation amount must be at least $5.")
              .show();
            allAmountsValid = false;
            return false; // Break the loop
          }
        });

        if (allAmountsValid) {
          $errorContainer.hide(); // Hide error message if all amounts are valid
        }

        return allAmountsValid;
      }
      console.log("We should NOT validate this");
      return true;
    }

    function validateStep() {
      let isValid = true; // Assume step is valid to start

      // Existing validation for inputs, selects, and textareas
      $.each($curInputs.filter(":not([type=radio])"), function () {
        const $this = $(this);
        $this.change();
      });

      $.each($curInputs.filter("[type=radio].radio-to-validate"), function () {
        const $this = $(this);
        $this.change();
      });

      if ($curInputs.is("[data-invalid]")) {
        isValid = false; // Found invalid inputs
      }

      // Specific validation for the "fixedAmountDonations" table at step 2
      if (curStep === 3 && !validateFixedAmountDonations()) {
        isValid = false; // Table validation failed
      }

      return isValid; // Return the overall validation status
    }

    function getCurInputs(step) {
      return $form
        .find('.registration-fieldset[data-step="' + step + '"]')
        .find("input, select, textarea");
    }
  }
});
